import React, { useMemo, useState } from "react";
import "./MyProduct.css";

const productsData = [
  { id: 1, title: "PERRUQUE PERRUQUE", price: 2500, image: "/qt1.jpg" },
  { id: 2, title: "PERRUQUE PERRUQUE", price: 2700, image: "/qt2.avif" },
  { id: 3, title: "PERRUQUE PERRUQUE", price: 3000, image: "/qt3.webp" },
  { id: 4, title: "PERRUQUE PERRUQUE", price: 2700, image: "/qt4.avif" },
  { id: 5, title: "PERRUQUE PERRUQUE", price: 3000, image: "/qt5.jpg" },
  { id: 6, title: "PERRUQUE ", price: 2900, image: "/qt6.webp" },
  { id: 7, title: "PERRUQUE ", price: 2900, image: "/qt7.jpg" },
  { id: 8, title: "PERRUQUE ", price: 2900, image: "/qt8.webp" },
  { id: 9, title: "PERRUQUE ", price: 3000, image: "/qt9.webp" },
  { id: 10, title: "PERRUQUE ", price: 3100, image: "/qt10.webp" },
  { id: 11, title: "PERRUQUE ", price: 3200, image: "/qt11.webp" },
  { id: 12, title: "PERRUQUE ", price: 2500, image: "/qt12.webp" },
  { id: 13, title: "PERRUQUE ", price: 3000, image: "/qt13.jpg" },
  { id: 14, title: "PERRUQUE ", price: 3000, image: "/qt14.webp" },
  { id: 15, title: "PERRUQUE ", price: 3200, image: "/qt15.webp" },
  { id: 16, title: "PERRUQUE ", price: 2500, image: "/qt16.jpg" },
  { id: 17, title: "PERRUQUE ", price: 2700, image: "/qt17.webp" },
  { id: 18, title: "PERRUQUE ", price: 3000, image: "/qt18.jpg" },
  { id: 19, title: "PERRUQUE ", price: 2700, image: "/qt19.avif" },
  { id: 20, title: "PERRUQUE ", price: 3000, image: "/qt20.jpg" },
  { id: 21, title: "PERRUQUE ", price: 2900, image: "/qt21.webp" },
  { id: 22, title: "PERRUQUE ", price: 2900, image: "/qt22.jpg" },
  { id: 23, title: "PERRUQUE ", price: 2900, image: "/qt23.jpg" },
  { id: 24, title: "PERRUQUE ", price: 3000, image: "/qt24.webp" },
  { id: 25, title: "PERRUQUE ", price: 3100, image: "/qt25.jpeg" },
  { id: 26, title: "PERRUQUE ", price: 3200, image: "/qt26.jpg" },
  { id: 27, title: "PERRUQUE ", price: 2500, image: "/qt27.webp" },
  { id: 28, title: "PERRUQUE ", price: 3000, image: "/qt28.jpg" },
  { id: 29, title: "PERRUQUE ", price: 3000, image: "/qt29.jpg" },
  { id: 30, title: "PERRUQUE ", price: 3200, image: "/qt30.webp" },
];

function ImageModal({ open, onClose, src, alt }) {
  React.useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="myProductModalOverlay-ctlg"
      role="dialog"
      aria-modal="true"
      aria-label="Aperçu image"
      onClick={onClose}
    >
      <div
        className="myProductModalPanel-ctlg"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="myProductModalClose-ctlg"
          type="button"
          onClick={onClose}
          aria-label="Fermer"
        >
          ×
        </button>

        <div className="myProductModalImgWrap-ctlg">
          <img className="myProductModalImg-ctlg" src={src} alt={alt} />
        </div>

        <div className="myProductModalCaption-ctlg">{alt}</div>
      </div>
    </div>
  );
}

export default function MyProduct({
  items = productsData,
  bannerTitleSmall = "CHEZ",
  bannerTitleBig = "GLORIA",
  brandText = "Hair",
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const list = useMemo(() => [...items], [items]);

  const openModal = (p) => {
    setSelected(p);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelected(null);
  };

  return (
    <section className="myProductSection-ctlg">
      <div className="myProductContainer-ctlg">
        {/* ✅ Bannière sticky */}
        <aside className="myProductBanner-ctlg" aria-label="Bannière">
          <div className="myProductLogoBox-ctlg">
            <div className="myProductLogoCircle-ctlg" aria-hidden="true">
              <span className="myProductLogoText-ctlg">{brandText}</span>
            </div>
          </div>

          <div className="myProductBannerTitle-ctlg">
            <span className="myProductBannerTitleSmall-ctlg">{bannerTitleSmall}</span>
            <span className="myProductBannerTitleBig-ctlg">{bannerTitleBig}</span>
          </div>

          <p className="myProductBannerHint-ctlg">Tel: +228 90 00 00 00 / Lome - Togo</p>
          <p className="myProductBannerHint-ctlg">Cliquez sur un produit pour agrandir</p>
        </aside>

        {/* ✅ Zone produits scrollable (hauteur écran) */}
        <div className="myProductScrollArea-ctlg">
          <div className="myProductGrid-ctlg" role="list">
            {list.map((p, index) => (
              <article
                className="myProductCard-ctlg"
                role="listitem"
                key={p.id ?? index}
                tabIndex={0}
                onClick={() => openModal(p)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") openModal(p);
                }}
              >
                <div className="myProductCardTop-ctlg">
                  <div className="myProductNumber-ctlg">
                    {String(index + 1).padStart(2, "0")}
                  </div>

                  <div className="myProductMeta-ctlg">
                    <h3 className="myProductTitle-ctlg" title={p.title}>
                      {p.title}
                    </h3>
                    <div className="myProductPrice-ctlg">{p.price}</div>
                  </div>
                </div>

                <div className="myProductImageWrap-ctlg">
                  <img
                    className="myProductImage-ctlg"
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    onClick={(e) => {
                      e.stopPropagation();
                      openModal(p);
                    }}
                  />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>

      <ImageModal
        open={modalOpen}
        onClose={closeModal}
        src={selected?.image}
        alt={selected?.title || ""}
      />
    </section>
  );
}
